import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Router} from "@angular/router";
import {Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {AuthService} from "../auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        // จัดการเฉพาะ error ที่เกี่ยวกับ authentication เท่านั้น
        if (error instanceof HttpErrorResponse && error.status === 401) {
          console.log('Unauthorized access detected, redirecting to login page');

          // ลบข้อมูล token และข้อมูลผู้ใช้ในระบบ
          sessionStorage.clear();
          localStorage.clear();

          // เด้งกลับไปยังหน้า login
          this.router.navigate(['/login']);
        }

        // ส่งต่อ error ไปให้ interceptor อื่นจัดการต่อ
        return throwError(() => error);
      })
    );
  }
}
